var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Organization wow bounceInUp"},[_c('div',{staticClass:"cont"},[_c('ComTitlte',{attrs:{"titleEn":"ORGANIZATION","titleZh":"组织架构"}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{attrs:{"src":require("../../assets/img/company/organization.png"),"alt":"..."}})])
}]

export { render, staticRenderFns }